import { v4 as uuid } from 'uuid';

import Document from '@/components/legal/Document';
import Section from '@/components/legal/Section';
import Subsection from '@/components/legal/Subsection';
import Subsubsection from '@/components/legal/Subsubsection';

import { AdminTermsContent, AdminTermsRes, AdminTermsSection } from './types';

const AdminTerms = ({ terms }: AdminTermsRes) => {
	const renderContentList = (content: AdminTermsContent) => {
		if (content.copy.length === 1) {
			// Render as a single element
			return <span>{content.copy[0]}</span>;
		}
		// Render as a list
		return (
			<ul>
				{content.copy.map(copy => {
					return <li key={copy}>{copy}</li>;
				})}
			</ul>
		);
	};

	const renderNestedSection = (section: AdminTermsSection, nestedLevel: number) => {
		// End of the section, simply render the content
		if (section.content) {
			return section.content.map(renderContentList);
		}
		if (section.sections) {
			return section.sections.map(nestedSection => {
				if (nestedLevel === 1) {
					return (
						<Subsection key={uuid()} title={nestedSection.title} isImportant={nestedSection.isImportant}>
							{renderNestedSection(nestedSection, nestedLevel + 1)}
						</Subsection>
					);
				}
				return (
					<Subsubsection key={uuid()} title={nestedSection.title}>
						{renderNestedSection(nestedSection, nestedLevel + 1)}
					</Subsubsection>
				);
			});
		}
	};
	return (
		<Document title={terms.name} lastChangedDate={terms.last_updated}>
			{terms.sections.map(section => (
				<Section key={section.title || uuid()} title={section.title}>
					{renderNestedSection(section, 1)}
				</Section>
			))}
		</Document>
	);
};

export default AdminTerms;
